import { Card, Empty, Row, Space, Statistic, Table, Typography } from "antd"

import { ucfirst } from "../../utils/Utils";

export default function ListReportCardSimplifiedView(props) {

    const {
        reportCardData = {},
        vendor = {},
    } = props

    const {acct = ""} = vendor; 

    const total = reportCardData.total;
    const individual_counts = Object.entries(reportCardData.individual_counts);

    const drawEmpty = () => {
        // Check if any category has missing items
        const hasData = individual_counts.some(([_, value]) => {
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === "object" && value !== null) return Object.keys(value).length > 0;
            return false;
        });
        if (hasData) return <></>;
        return (
            <Table
                size="small"
                style={{ "width": "100%" }}
                dataSource={[]}
                columns={[{ title: <>&nbsp;</> }]}
            />
        );
    }

    // intercept related...
    const getTitle = (_str) => {

        if(_str === "related"){
            return "Comparables";
        }

        return _str; 
    }

    return (
        <Row>
            {drawEmpty()}
            {individual_counts.map((data) => {
                const count = typeof data[1] === "object" && data[1] !== null
                    ? Object.keys(data[1]).length
                    : Array.isArray(data[1])
                        ? data[1].length
                        : 0;
                if (count < total) {
                    return (
                        <Card
                            style={{ "margin": "10px", "width": "300px" }}
                            title={<Typography.Title level={5}>{ucfirst(getTitle(data[0])) === "Pubstock" ? acct + ' Pubstock' : ucfirst(getTitle(data[0]))}</Typography.Title>}>
                            <Statistic
                                style={{ "backgroundColor": "inherit" }}
                                value={total - count}
                                suffix={"/" + total + " missing"}
                            />
                        </Card>
                    )
                }
                return null;
            })}
        </Row>
    )
}